import {
  blue,
  brown,
  common,
  green,
  grey,
  lime,
  maroon,
  navy,
  olive,
  orange,
  pink,
  purple,
  red,
  teal,
  turquoise,
  violet,
  yellow,
} from '../../colors';
import { createMuiBackdrop } from '../../utils';

// `lighter` and `faint` are placeholders: they exist because the shared
// PaletteColor type requires them, but no dark-mode design has defined what a
// subtly tinted surface should be here. Revisit when dark mode is designed.
const palette = {
  background: {
    default: common.black,
    paper: common.dark,
    backdrop: createMuiBackdrop(grey[200]),
  },
  primary: {
    main: blue[80],
    dark: blue[100],
    darkest: blue[120],
    light: blue[60],
    lightest: blue[40],
    lighter: blue[20],
    faint: blue[10],
    contrastText: common.dark,
  },
  secondary: {
    main: grey[80],
    dark: grey[100],
    darkest: grey[120],
    light: grey[60],
    lightest: grey[40],
    lighter: grey[40],
    faint: grey[10],
    contrastText: common.dark,
  },
  error: {
    main: red[80],
    dark: red[100],
    darkest: red[120],
    light: red[60],
    lightest: red[40],
    lighter: red[20],
    faint: red[10],
    contrastText: common.dark,
  },
  warning: {
    main: yellow[80],
    dark: yellow[100],
    darkest: yellow[120],
    light: yellow[60],
    lightest: yellow[40],
    lighter: yellow[20],
    faint: yellow[10],
    contrastText: common.dark,
  },
  info: {
    main: navy[80],
    dark: navy[100],
    darkest: navy[120],
    light: navy[60],
    lightest: navy[40],
    lighter: navy[20],
    faint: navy[10],
    contrastText: common.dark,
  },
  success: {
    main: green[80],
    dark: green[100],
    darkest: green[120],
    light: green[60],
    lightest: green[40],
    lighter: green[20],
    faint: green[10],
    contrastText: common.dark,
  },
  green: {
    main: green[80],
    dark: green[100],
    darkest: green[120],
    light: green[60],
    lightest: green[40],
    lighter: green[20],
    faint: green[10],
    contrastText: common.dark,
  },
  yellow: {
    main: yellow[80],
    dark: yellow[100],
    darkest: yellow[120],
    light: yellow[60],
    lightest: yellow[40],
    lighter: yellow[20],
    faint: yellow[10],
    contrastText: common.dark,
  },
  red: {
    main: red[80],
    dark: red[100],
    darkest: red[120],
    light: red[60],
    lightest: red[40],
    lighter: red[20],
    faint: red[10],
    contrastText: common.dark,
  },
  blue: {
    main: blue[80],
    dark: blue[100],
    darkest: blue[120],
    light: blue[60],
    lightest: blue[40],
    lighter: blue[20],
    faint: blue[10],
    contrastText: common.dark,
  },
  teal: {
    main: teal[80],
    dark: teal[100],
    darkest: teal[120],
    light: teal[60],
    lightest: teal[40],
    lighter: teal[20],
    faint: teal[10],
    contrastText: common.dark,
  },
  pink: {
    main: pink[80],
    dark: pink[100],
    darkest: pink[120],
    light: pink[60],
    lightest: pink[40],
    lighter: pink[20],
    faint: pink[10],
    contrastText: common.dark,
  },
  purple: {
    main: purple[80],
    dark: purple[100],
    darkest: purple[120],
    light: purple[60],
    lightest: purple[40],
    lighter: purple[20],
    faint: purple[10],
    contrastText: common.dark,
  },
  brown: {
    main: brown[80],
    dark: brown[100],
    darkest: brown[120],
    light: brown[60],
    lightest: brown[40],
    lighter: brown[20],
    faint: brown[10],
    contrastText: common.dark,
  },
  orange: {
    main: orange[80],
    dark: orange[100],
    darkest: orange[120],
    light: orange[60],
    lightest: orange[40],
    lighter: orange[20],
    faint: orange[10],
    contrastText: common.dark,
  },
  lime: {
    main: lime[80],
    dark: lime[100],
    darkest: lime[120],
    light: lime[60],
    lightest: lime[40],
    lighter: lime[20],
    faint: lime[10],
    contrastText: common.dark,
  },
  navy: {
    main: navy[80],
    dark: navy[100],
    darkest: navy[120],
    light: navy[60],
    lightest: navy[40],
    lighter: navy[20],
    faint: navy[10],
    contrastText: common.dark,
  },
  violet: {
    main: violet[80],
    dark: violet[100],
    darkest: violet[120],
    light: violet[60],
    lightest: violet[40],
    lighter: violet[20],
    faint: violet[10],
    contrastText: common.dark,
  },
  maroon: {
    main: maroon[80],
    dark: maroon[100],
    darkest: maroon[120],
    light: maroon[60],
    lightest: maroon[40],
    lighter: maroon[20],
    faint: maroon[10],
    contrastText: common.dark,
  },
  turquoise: {
    main: turquoise[80],
    dark: turquoise[100],
    darkest: turquoise[120],
    light: turquoise[60],
    lightest: turquoise[40],
    lighter: turquoise[20],
    faint: turquoise[10],
    contrastText: common.dark,
  },
  olive: {
    main: olive[80],
    dark: olive[100],
    darkest: olive[120],
    light: olive[60],
    lightest: olive[40],
    lighter: olive[20],
    faint: olive[10],
    contrastText: common.dark,
  },
  black: {
    main: grey[80],
    dark: grey[100],
    darkest: grey[120],
    light: grey[60],
    lightest: grey[40],
    lighter: grey[20],
    faint: grey[10],
    contrastText: common.dark,
  },
  text: {
    header: grey[20],
    primary: grey[40],
    secondary: grey[60],
    disabled: grey[80],
  },
  action: {
    hover: blue[140],
  },
  divider: grey[140],
};

export default palette;
